import React, { useState } from 'react';
import { Plus } from 'lucide-react';

const AddSkillInput = ({ skills = [], onAdd, disabled = false }) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    const cleaned = value.trim();
    if (!cleaned) {
      setError('Enter a skill first');
      return;
    }
    const exists = skills.some((skill) => (skill.skill_name || skill.name || '').toLowerCase() === cleaned.toLowerCase());
    if (exists) {
      setError('That skill is already added');
      return;
    }
    setError('');
    onAdd(cleaned);
    setValue('');
  };

  return (
    <form onSubmit={handleSubmit} className="mt-5">
      <div className="flex flex-col gap-3 sm:flex-row">
        <input
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
            if (error) setError('');
          }}
          disabled={disabled}
          placeholder="Add missing skill"
          className="min-h-12 flex-1 rounded-lg border border-slate-700/70 bg-slate-950/60 px-4 py-3 text-sm text-white outline-none transition placeholder:text-slate-500 focus:border-purple-400 focus:ring-2 focus:ring-purple-500/20 disabled:cursor-not-allowed disabled:opacity-60"
        />
        <button
          type="submit"
          disabled={disabled}
          className="inline-flex min-h-12 items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-purple-600 to-pink-600 px-5 py-3 text-sm font-bold text-white shadow-xl shadow-purple-500/20 transition hover:-translate-y-0.5 hover:from-purple-700 hover:to-pink-700 hover:shadow-pink-500/25 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <Plus className="h-4 w-4" />
          Add
        </button>
      </div>
      {error && <p className="mt-2 text-sm font-medium text-pink-200">{error}</p>}
    </form>
  );
};

export default AddSkillInput;

